import gql from 'graphql-tag';
const PeopleAddressFragment = gql`
  fragment PeopleAddressFragment on PeopleAddressesModel {
    id
    region_city_id
    dadata {
      id
      geoLat
      geoLon
      country
      areaType
      area
      cityType
      city
      settlementType
      settlement
      streetType
      street
      houseType
      house
      blockType
      block
    }
    coords
    fio
    phone
    title
    flat
    comment
    deleted
    primary
    confirmedByUser
    isValidForExpress
  }
`;

const AuthQL = {
  getCartToken: gql`
    query me {
      me {
        id
        newLoyaltyProgram
        hash
        birthdayDate
        #status {
        #  id
        #  title
        #}

        bill {
          billAmount
          log {
            id
            order {
              id
            }
            amount
            type
            comment
            dateTime
          }
        }

        mainImage
        fio
        phone
        email
        cookieId
        addresses {
          id
          region_city_id
          dadata {
            id
            geoLat
            geoLon
            country
            areaType
            area
            cityType
            city
            settlementType
            settlement
            streetType
            street
            houseType
            house
            blockType
            block
          }
          coords
          fio
          phone
          title
          flat
          comment
          deleted
          primary
          confirmedByUser
          isValidForExpress
        }
      }
    }
  `,
  removePeopleAddress: gql`
    mutation removePeopleAddress($id: Int) {
      removePeopleAddress(peopleAddressId: $id) {
        success
        error
        errorCode
        warning
        info
        people {
          id
        }
      }
    }
  `,
  addPeopleAddress: gql`
    mutation addPeopleAddress($data: PeopleAddressInput!) {
      addPeopleAddress(peopleAddressData: $data) {
        success
        error
        peopleAddress {
          ...PeopleAddressFragment
        }
      }
    }
    ${PeopleAddressFragment}
  `,
  updatePeopleAddress: gql`
    mutation updatePeopleAddress($data: PeopleAddressInput!) {
      updatePeopleAddress(peopleAddressData: $data) {
        success
        error
        peopleAddress {
          ...PeopleAddressFragment
        }
      }
    }
    ${PeopleAddressFragment}
  `,
  updatePeople: gql`
    mutation updatePeople($data: PeopleUpdateInput) {
      updatePeople(data: $data) {
        success
        error
        people {
          settingsItem {
            save_payment_card
          }
        }
      }
    }
  `
};

export default AuthQL;
